import { Link } from "react-router-dom";
import { useSiteContent, mediaUrl } from "../../lib/siteContent";

export default function SiteBanner() {
  const site = useSiteContent();
  const banner = site.banner || {};
  if (!banner.enabled) return null;
  const image = mediaUrl(banner.image);
  const video = mediaUrl(banner.video_url);
  const inner = (
    <div className="relative overflow-hidden rounded-3xl min-h-[180px] md:min-h-[220px] bg-[#311b52]">
      {video ? (
        <video className="absolute inset-0 w-full h-full object-cover opacity-50" src={video} autoPlay muted loop playsInline />
      ) : image ? (
        <img src={image} alt="" className="absolute inset-0 w-full h-full object-cover opacity-50" />
      ) : null}
      <div className="relative z-10 px-6 py-10 md:px-12 md:py-14 text-white max-w-3xl">
        {banner.title && <h2 className="text-2xl md:text-3xl font-bold" style={{ fontFamily: "Poppins" }}>{banner.title}</h2>}
        {banner.body && <p className="mt-2 text-sm md:text-base text-white/85" style={{ fontFamily: "Montserrat" }}>{banner.body}</p>}
        {banner.cta_label && banner.cta_url && (
          <span className="inline-flex mt-5 bg-[#f37721] text-white rounded-full px-5 py-2.5 text-sm font-semibold">{banner.cta_label}</span>
        )}
      </div>
    </div>
  );
  return (
    <section data-testid="cms-banner" className="py-8 md:py-10 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {banner.cta_url ? <Link to={banner.cta_url}>{inner}</Link> : inner}
      </div>
    </section>
  );
}
